import { RechtMasterListEntry } from '../../core/gb-api';

export function getQueryParams(recht: RechtMasterListEntry) {
  if (!recht || !recht.version) {
    return;
  }
  return { id: recht.id.id, versionId: recht.version.id.id };
}
